import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // Timeline Menu
  nativeCommsMessageTypes.EMBED_IN_NARRATIVE_FOLDER
];
